import { render, staticRenderFns } from "./HistogramWrapper.vue?vue&type=template&id=34c356ec&scoped=true&"
import script from "./HistogramWrapper.vue?vue&type=script&lang=js&"
export * from "./HistogramWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c356ec",
  null
  
)

export default component.exports